<template>
    <div class="clients-event">
        <a
            class="btn btn-primary pull-right"
            @click.prevent="$refs.resgisterEventModal.open()"
            v-if="$store.dispatch('hasPermission', 'reports')  && !hideButton"
        >
            <slot> {{ t('customEvents-register_event_button') }} </slot>
        </a>

        <info-modal id="add-action-modal" ref="resgisterEventModal">
            <template slot="title">{{ t('customEvents-register_event_title') }}</template>
            <div slot="body">
                <div class="search-bar">
                    <input
                        type="text"
                        class="form-control"
                        :placeholder="t('customEvents-search_event_placeholder')"
                        v-model="searchQuery"
                    />
                </div>

                <div v-if="searchQuery && events.length === 0 && !loading" class="alert alert-info" style="margin-top: 15px;">
                    <span v-html="t('customEvents-no_results_found', [searchQuery])"></span>
                    <a href="#" @click.prevent="clearSearch" class="clean-search">
                      {{ t('customEvents-clear_search') }}
                    </a>
                </div>

                <div class="empty-state" v-if="!hasEvents && !loading && !searchQuery">
                    <p>{{ t('customEvents-no_events_created') }}</p>
                    <button
                        class="btn btn-primary"
                        @click="() => {
                            closeEventToRegisterModal();
                            $router.push('/custom-events');
                        }"
                    >
                        {{ t('customEvents-create_event_button') }}
                    </button>
                </div>

                <div class="btn-list" v-if="hasEvents">
                    <button
                        v-for="event in events"
                        :key="event.id"
                        class="btn btn-default"
                        @click="selectEventToRegister(event)"
                    >
                        {{ event.title }}
                    </button>
                </div>

                <div class="pagination-controls" v-if="pagination.total > 0">
                    <kv-pagination
                        :total="pagination.total"
                        :current-page="pagination.page"
                        :items-per-page="pagination.limit"
                        :show-items-per-page="false"
                        @page-change="goToPage"
                    />
                </div>
            </div>
        </info-modal>

        <confirm
            id="delete-modal"
            ref="confirmResgisterEvent"
            @confirm="resgisterEvent"
            @cancel="cancelEventToRegister"
        >
            <template slot="title">{{ t('customEvents-register_confirmation_title') }}</template>
            <template slot="body">
                <p v-if="toRegisterEvent" v-html="t('customEvents-register_confirmation_body', [toRegisterEvent.title])">
                </p>
            </template>
        </confirm>
    </div>
</template>
<script>
import keviApi from "../keviApi";
import KvPagination from "../components/ui/kv-pagination.vue";

export default {
    components: {
        KvPagination
    },
    props: {
        client: Object,
           hideButton: {
            type: Boolean,
            default: false
        }
    },
    data: function () {
        return {
            events: [],
            toRegisterEvent: null,
            searchQuery: "",
            searchDebounceTimer: null,
            loading: false,
            pagination: {
                total: 0,
                page: 1,
                limit: 20,
                totalPages: 0,
                hasNext: false,
                hasPrev: false,
            },
        };
    },
    computed: {
        hasEvents() {
            return this.events.length > 0;
        },
        place() {
            return this.$store.state.place;
        },
        user() {
            return this.$store.state.user;
        },
    },
    methods: {
        t: function (term, replaces) {
            return this.$root.t(term, replaces);
        },
        openModal() {
            if (this.$store.dispatch('hasPermission', 'reports')) {
                this.$refs.resgisterEventModal?.open();
            }
        },
        selectEventToRegister(event) {
            this.toRegisterEvent = event;
            window.mixpanel?.track(
                "Custom Event select to register",
                this.toRegisterEvent,
            );
            this.$refs.resgisterEventModal.close();
            this.$refs.confirmResgisterEvent.open();
        },
        cancelEventToRegister() {
            window.mixpanel?.track(
                "Custom Event cancel register",
                this.toRegisterEvent,
            );
            this.toRegisterEvent = null;
            this.$refs.confirmResgisterEvent.close();
            this.$refs.resgisterEventModal.open();
        },
        closeEventToRegisterModal() {
            window.mixpanel?.track(
                "Custom Event close modal register",
                this.toRegisterEvent,
            );
            this.toRegisterEvent = null;
            this.$refs.resgisterEventModal.close();
        },
        clearSearch() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.searchQuery = "";
            this.pagination.page = 1;
            this.updateEventList();
        },
        updateEventList() {
            this.loading = true;
            const params = `?page=${this.pagination.page}&limit=${this.pagination.limit}&search=${encodeURIComponent(this.searchQuery)}`;
            var options = keviApi.getOptions(`custom-event/events${params}`);
            this.$http(options).then(
                function (response) {
                    if (response.status === 200) {
                        if (response.body.data && response.body.pagination) {
                            this.events = response.body.data;
                            this.pagination = response.body.pagination;
                        }
                    }
                    this.loading = false;
                },
                () => {
                    this.loading = false;
                },
            );
        },
        goToPage: function (page) {
            if (page >= 1 && page <= this.pagination.totalPages) {
                this.pagination.page = page;
                this.updateEventList();
            }
        },
        resgisterEvent() {
            this.$emit("loading", true);
            var options = keviApi.getOptions(
                "custom-event/register-event",
                "POST",
                {
                    clients_id: this.client.id,
                    custom_events_id: this.toRegisterEvent.id,
                },
            );
            this.$http(options).then(
                function (response) {
                    if (response.status === 200) {
                        this.$store.dispatch(
                            "notification/success",
                            this.t("customEvents-register_success"),
                        );
                        window.mixpanel?.track("Custom Event resgister", {
                            client_id: this.client.id,
                            client_phone_number: this.client.phone,
                            client_name: this.client.first_name || "",
                            client_last_name: this.client.last_name || "",
                            client_completed_registration:
                                !!this.client.first_name,
                            place_id: this.place.id,
                            place_name: this.user.place_name,
                            place_branch_name: this.user.branch_title,
                            user_name: this.user.name,
                            user_username: this.user.username,
                            user_email: this.user.email,
                            event: this.toRegisterEvent.title,
                        });
                    } else {
                        this.$store.dispatch(
                            "notification/warning",
                            this.t("customEvents-register_error"),
                        );
                    }
                    this.$emit("update");
                    this.$emit("loading", false);
                },
                function () {
                    this.$store.dispatch(
                        "notification/warning",
                        this.t("customEvents-register_error"),
                    );
                    this.$emit("loading", false);
                },
            );
        },
    },
    watch: {
        searchQuery() {
            if (this.searchDebounceTimer) {
                clearTimeout(this.searchDebounceTimer);
            }
            this.searchDebounceTimer = setTimeout(() => {
                this.pagination.page = 1;
                this.updateEventList();
            }, 500);
        },
    },
    async mounted() {
        this.updateEventList();
    },
};
</script>
<style lang="less" scoped>
.clean-search {
    text-decoration: underline;
    margin-top: 16px;
}
.clients-event {
    .modal-body {
        display: flex;
        flex-direction: column;

        .btn-list {
            display: flex;
            flex-direction: column;
            gap: 4px;
            overflow-y: auto;

            button {
                width: 100%;
                text-align: left;
                padding: 8px 12px;
                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 0;
                background-color: #004d26;
                color: white;
                border: none;
                border-radius: 4px;

                &:hover {
                    background-color: #006633;
                    color: white;
                }
            }
        }

        .empty-state {
            text-align: center;
            padding: 40px 20px;

            p {
                color: #666;
                margin-bottom: 20px;
            }
        }

        .pagination-controls {
            border-top: 1px solid #e0e0e0;
        }
    }
}
</style>
